module.exports = __webpack_public_path__ + "static/media/restore.b95c1fec.svg";